import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import classNames from 'classnames'
import { checkCDN } from 'shared/lib/checkCDN'
import { MessageCardType, type MessageProps } from 'widgets/MessageCard/ui/types'
import { ConversationMessageCardItem } from 'widgets/MessageCard/ui/ConversationMessageCardItem/ConversationMessageCardItem'
import { DateContent } from 'widgets/MessageCard/ui/DateContent/DateContent'
import { BodyRawContent } from 'widgets/MessageCard/ui/BodyRawContent/BodyRawContent'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import styles from './styles.module.scss'

type ITextContentProps = MessageProps & {
  selectedSearch: string
}

export const TextContent: FC<ITextContentProps> = observer((props) => {
  const presentationStore = usePresentationModeContext()
  const { body, previewGifs, undoPending, isFailed } = props.message
  const noPreviews = !previewGifs.length
  const noBody = !body

  const onOpenPresentationOtherAttachments = (index: number) => () => {
    presentationStore.setAttachments(previewGifs, index, true)
  }

  if (noBody && noPreviews && !isFailed) return null

  return (
    <ConversationMessageCardItem
      className={classNames({
        [styles.withPreviews]: noPreviews,
        [styles.undoPendingMessage]: undoPending,
      })}
      message={props.message}
      type={previewGifs.length ? MessageCardType.GifPreview : MessageCardType.Text}
    >
      {previewGifs.map((gif, index) => (
        <img
          key={gif.source}
          src={gif.source}
          alt=''
          className={styles.img}
          onClick={onOpenPresentationOtherAttachments(index)}
          aria-hidden={true}
          {...(checkCDN(gif.source) ? { crossOrigin: 'use-credentials' } : null)}
        />
      ))}
      <BodyRawContent message={props.message} selectedSearch={props.selectedSearch} />
      <DateContent {...props} />
    </ConversationMessageCardItem>
  )
})
